// The browser owns the snapshots. No duplicated UI, image downloads or canvas
// capture is needed, and a superseded choice cannot apply after a newer one.
export function createThemeTransition(doc = document) {
  let sequence = 0, active = null, timer = null;
  const clear = () => {
    clearTimeout(timer); timer = null;
    delete doc.documentElement.dataset.themeTransition;
    doc.documentElement.style.removeProperty('--tl-theme-veil');
  };
  const stop = () => { sequence++; active?.skipTransition(); active = null; clear(); };
  return {
    stop,
    run(commit, { changed, from, quiet = false, animate = true }) {
      stop(); const current = sequence;
      let reduced = false;
      try { reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true; } catch {}
      if (!changed || !animate || reduced || doc.visibilityState === 'hidden') { commit(false); return; }
      if (typeof doc.startViewTransition === 'function') {
        doc.documentElement.dataset.themeTransition = quiet ? 'fade' : 'reveal';
        try {
          const transition = doc.startViewTransition(() => { if (current === sequence) commit(true); });
          active = transition;
          transition.ready.catch(() => {});
          transition.finished.then(() => { if (current === sequence) { active = null; clear(); } }, () => { if (current === sequence) { active = null; clear(); } });
          return;
        } catch { clear(); }
      }
      doc.documentElement.style.setProperty('--tl-theme-veil', from);
      doc.documentElement.dataset.themeTransition = 'fallback';
      commit(false);
      timer = setTimeout(() => { if (current === sequence) clear(); }, 360);
    },
  };
}
